import { useResolvedPath } from "react-router";
import {
  ProfilePermissionType,
  ProfilePermissionTypes,
} from "../../../data/dtos/profile-config.dto";
import { UserVerificationNeeded } from "../information/content-restricted-pages/UserVerificationNeeded";
import { useGetKeyPartiesQuery } from "../../../data/useProfile";
import { ErrorPage } from "../../shared/ErrorPage";
import KeyPartiesSkeleton from "./components/KeyPartiesSkeleton";
import KeyPartiesSection from "./components/KeyPartiesSection";

export interface KeyPartiesProps {
  isPendingActionsLoading: boolean;
  permission: ProfilePermissionType;
  canDelete: boolean;
}

export const KeyParties = ({
  isPendingActionsLoading,
  permission,
  canDelete,
}: KeyPartiesProps) => {
  const { pathname: currentPath } = useResolvedPath("");
  const keyPartiesQuery = useGetKeyPartiesQuery();

  if (permission === ProfilePermissionTypes.USER_VERIFICATION_NOT_SUBMITTED) {
    return (
      <UserVerificationNeeded
        isVerificationInReview={false}
        currentPath={currentPath}
      />
    );
  }

  if (permission === ProfilePermissionTypes.USER_VERIFICATION_PENDING) {
    return (
      <UserVerificationNeeded
        isVerificationInReview
        currentPath={currentPath}
      />
    );
  }

  if (isPendingActionsLoading || keyPartiesQuery.isPending) {
    return <KeyPartiesSkeleton />;
  }

  if (keyPartiesQuery.isError) {
    return <ErrorPage />;
  }

  const isReadOnly = permission === ProfilePermissionTypes.READ_ONLY;

  return (
    <KeyPartiesSection
      keyParties={keyPartiesQuery.data.keyParties}
      isRefreshing={keyPartiesQuery.isFetching}
      isReadOnly={isReadOnly}
      canDelete={canDelete}
    />
  );
};
